import { c as _c } from "react/compiler-runtime";
import { COUNTRIES, US_STATES_AND_ARMED_FORCES, VAULT_DOT_SEPARATOR, type VaultFormData } from '@onefootprint/core';
import { IcoBuilding24 } from '@onefootprint/icons';
import type { DataIdentifier, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type ResidentialAddressProps = {
  locale: Locale;
  residentialAddressCountries?: string[];
  disabledDis: DataIdentifier[];
};
export const ResidentialAddress = t0 => {
  const $ = _c(132);
  const {
    locale,
    residentialAddressCountries,
    disabledDis
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== disabledDis || $[2] !== locale || $[3] !== residentialAddressCountries || $[4] !== t) {
    const filteredCountries = residentialAddressCountries?.length ? COUNTRIES.filter(c => residentialAddressCountries.includes(c.value)) : COUNTRIES;
    t13 = "flex flex-col gap-4";
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div className="flex gap-1 items-center"><IcoBuilding24 color="primary" /><span className="text-label-2 text-primary">Your address</span></div>;
      $[19] = t14;
    } else {
      t14 = $[19];
    }
    T0 = Form.AddressLines;
    t3 = "id";
    t4 = VAULT_DOT_SEPARATOR;
    t5 = true;
    let t15;
    if ($[20] !== disabledDis) {
      t15 = disabledDis.includes("id.country");
      $[20] = disabledDis;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    let t16;
    if ($[22] !== disabledDis) {
      t16 = disabledDis.includes("id.address_line1");
      $[22] = disabledDis;
      $[23] = t16;
    } else {
      t16 = $[23];
    }
    let t17;
    if ($[24] !== disabledDis) {
      t17 = disabledDis.includes("id.address_line2");
      $[24] = disabledDis;
      $[25] = t17;
    } else {
      t17 = $[25];
    }
    let t18;
    if ($[26] !== disabledDis) {
      t18 = disabledDis.includes("id.city");
      $[26] = disabledDis;
      $[27] = t18;
    } else {
      t18 = $[27];
    }
    let t19;
    if ($[28] !== disabledDis) {
      t19 = disabledDis.includes("id.state");
      $[28] = disabledDis;
      $[29] = t19;
    } else {
      t19 = $[29];
    }
    let t20;
    if ($[30] !== disabledDis) {
      t20 = disabledDis.includes("id.zip");
      $[30] = disabledDis;
      $[31] = t20;
    } else {
      t20 = $[31];
    }
    if ($[32] !== t15 || $[33] !== t16 || $[34] !== t17 || $[35] !== t18 || $[36] !== t19 || $[37] !== t20) {
      t6 = {
        country: t15,
        addressLine1: t16,
        addressLine2: t17,
        city: t18,
        state: t19,
        zip: t20
      };
      $[32] = t15;
      $[33] = t16;
      $[34] = t17;
      $[35] = t18;
      $[36] = t19;
      $[37] = t20;
      $[38] = t6;
    } else {
      t6 = $[38];
    }
    if ($[39] !== locale) {
      t7 = {
        locale
      };
      $[39] = locale;
      $[40] = t7;
    } else {
      t7 = $[40];
    }
    t8 = filteredCountries;
    t9 = US_STATES_AND_ARMED_FORCES;
    let t21;
    if ($[41] !== t) {
      t21 = t(_temp);
      $[41] = t;
      $[42] = t21;
    } else {
      t21 = $[42];
    }
    let t22;
    if ($[43] !== t) {
      t22 = t(_temp2);
      $[43] = t;
      $[44] = t22;
    } else {
      t22 = $[44];
    }
    let t23;
    if ($[45] !== t) {
      t23 = t(_temp3);
      $[45] = t;
      $[46] = t23;
    } else {
      t23 = $[46];
    }
    let t24;
    if ($[47] !== t) {
      t24 = t(_temp4);
      $[47] = t;
      $[48] = t24;
    } else {
      t24 = $[48];
    }
    let t25;
    if ($[49] !== t) {
      t25 = t(_temp5);
      $[49] = t;
      $[50] = t25;
    } else {
      t25 = $[50];
    }
    let t26;
    if ($[51] !== t) {
      t26 = t(_temp6);
      $[51] = t;
      $[52] = t26;
    } else {
      t26 = $[52];
    }
    let t27;
    if ($[53] !== t) {
      t27 = t(_temp7);
      $[53] = t;
      $[54] = t27;
    } else {
      t27 = $[54];
    }
    let t28;
    if ($[55] !== t) {
      t28 = t(_temp8);
      $[55] = t;
      $[56] = t28;
    } else {
      t28 = $[56];
    }
    let t29;
    if ($[57] !== t) {
      t29 = t(_temp9);
      $[57] = t;
      $[58] = t29;
    } else {
      t29 = $[58];
    }
    if ($[59] !== t21 || $[60] !== t22 || $[61] !== t23 || $[62] !== t24 || $[63] !== t25 || $[64] !== t26 || $[65] !== t27 || $[66] !== t28 || $[67] !== t29) {
      t10 = {
        country: t21,
        addressLine1: t22,
        addressLine1International: t23,
        addressLine2: t24,
        addressLine2International: t25,
        city: t26,
        state: t27,
        stateInternational: t28,
        zip: t29
      };
      $[59] = t21;
      $[60] = t22;
      $[61] = t23;
      $[62] = t24;
      $[63] = t25;
      $[64] = t26;
      $[65] = t27;
      $[66] = t28;
      $[67] = t29;
      $[68] = t10;
    } else {
      t10 = $[68];
    }
    let t30;
    if ($[69] !== t) {
      t30 = t(_temp10);
      $[69] = t;
      $[70] = t30;
    } else {
      t30 = $[70];
    }
    let t31;
    if ($[71] !== t) {
      t31 = t(_temp11);
      $[71] = t;
      $[72] = t31;
    } else {
      t31 = $[72];
    }
    let t32;
    if ($[73] !== t) {
      t32 = t(_temp12);
      $[73] = t;
      $[74] = t32;
    } else {
      t32 = $[74];
    }
    let t33;
    if ($[75] !== t) {
      t33 = t(_temp13);
      $[75] = t;
      $[76] = t33;
    } else {
      t33 = $[76];
    }
    let t34;
    if ($[77] !== t) {
      t34 = t(_temp14);
      $[77] = t;
      $[78] = t34;
    } else {
      t34 = $[78];
    }
    let t35;
    if ($[79] !== t) {
      t35 = t(_temp15);
      $[79] = t;
      $[80] = t35;
    } else {
      t35 = $[80];
    }
    let t36;
    if ($[81] !== t) {
      t36 = t(_temp16);
      $[81] = t;
      $[82] = t36;
    } else {
      t36 = $[82];
    }
    let t37;
    if ($[83] !== t) {
      t37 = t(_temp17);
      $[83] = t;
      $[84] = t37;
    } else {
      t37 = $[84];
    }
    if ($[85] !== t30 || $[86] !== t31 || $[87] !== t32 || $[88] !== t33 || $[89] !== t34 || $[90] !== t35 || $[91] !== t36 || $[92] !== t37) {
      t11 = {
        country: t30,
        addressLine1: t31,
        addressLine2: t32,
        addressLine2International: t33,
        city: t34,
        state: t35,
        stateInternational: t36,
        zip: t37
      };
      $[85] = t30;
      $[86] = t31;
      $[87] = t32;
      $[88] = t33;
      $[89] = t34;
      $[90] = t35;
      $[91] = t36;
      $[92] = t37;
      $[93] = t11;
    } else {
      t11 = $[93];
    }
    let t38;
    if ($[94] !== t) {
      t38 = t(_temp18);
      $[94] = t;
      $[95] = t38;
    } else {
      t38 = $[95];
    }
    let t39;
    if ($[96] !== t) {
      t39 = t(_temp19);
      $[96] = t;
      $[97] = t39;
    } else {
      t39 = $[97];
    }
    let t40;
    if ($[98] !== t) {
      t40 = t(_temp20);
      $[98] = t;
      $[99] = t40;
    } else {
      t40 = $[99];
    }
    let t41;
    if ($[100] !== t) {
      t41 = t(_temp21);
      $[100] = t;
      $[101] = t41;
    } else {
      t41 = $[101];
    }
    let t42;
    if ($[102] !== t) {
      t42 = t(_temp22);
      $[102] = t;
      $[103] = t42;
    } else {
      t42 = $[103];
    }
    let t43;
    if ($[104] !== t) {
      t43 = t(_temp23);
      $[104] = t;
      $[105] = t43;
    } else {
      t43 = $[105];
    }
    if ($[106] !== t38 || $[107] !== t39 || $[108] !== t40 || $[109] !== t41 || $[110] !== t42 || $[111] !== t43) {
      t12 = {
        country: t38,
        addressLine1: t39,
        addressLine2: t40,
        city: t41,
        state: t42,
        zip: t43
      };
      $[106] = t38;
      $[107] = t39;
      $[108] = t40;
      $[109] = t41;
      $[110] = t42;
      $[111] = t43;
      $[112] = t12;
    } else {
      t12 = $[112];
    }
    t2 = t(_temp24, {
      countryName: filteredCountries[0]?.label
    });
    $[1] = disabledDis;
    $[2] = locale;
    $[3] = residentialAddressCountries;
    $[4] = t;
    $[5] = T0;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t13;
    $[10] = t14;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    T0 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t13 = $[9];
    t14 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t15;
  if ($[113] !== t2) {
    t15 = {
      countryDisabled: t2
    };
    $[113] = t2;
    $[114] = t15;
  } else {
    t15 = $[114];
  }
  let t16;
  if ($[115] !== T0 || $[116] !== t10 || $[117] !== t11 || $[118] !== t12 || $[119] !== t15 || $[120] !== t3 || $[121] !== t4 || $[122] !== t5 || $[123] !== t6 || $[124] !== t7 || $[125] !== t8 || $[126] !== t9) {
    t16 = <T0 prefix={t3} vaultSeparator={t4} required={t5} disabled={t6} l10n={t7} countries={t8} stateOptions={t9} labels={t10} placeholders={t11} errors={t12} hints={t15} />;
    $[115] = T0;
    $[116] = t10;
    $[117] = t11;
    $[118] = t12;
    $[119] = t15;
    $[120] = t3;
    $[121] = t4;
    $[122] = t5;
    $[123] = t6;
    $[124] = t7;
    $[125] = t8;
    $[126] = t9;
    $[127] = t16;
  } else {
    t16 = $[127];
  }
  let t17;
  if ($[128] !== t13 || $[129] !== t14 || $[130] !== t16) {
    t17 = <div className={t13}>{t14}{t16}</div>;
    $[128] = t13;
    $[129] = t14;
    $[130] = t16;
    $[131] = t17;
  } else {
    t17 = $[131];
  }
  return t17;
};
function _temp($) {
  return $.fields.address.country.label;
}
function _temp2($_0) {
  return $_0.fields.address.addressLine1.label;
}
function _temp3($_1) {
  return $_1.fields.address.addressLine1.internationalLabel;
}
function _temp4($_2) {
  return $_2.fields.address.addressLine2.label;
}
function _temp5($_3) {
  return $_3.fields.address.addressLine2.internationalLabel;
}
function _temp6($_4) {
  return $_4.fields.address.city.label;
}
function _temp7($_5) {
  return $_5.fields.address.state.label;
}
function _temp8($_6) {
  return $_6.fields.address.state.internationalLabel;
}
function _temp9($_7) {
  return $_7.fields.address.zip.label;
}
function _temp10($_8) {
  return $_8.fields.address.country.placeholder;
}
function _temp11($_9) {
  return $_9.fields.address.addressLine1.placeholder;
}
function _temp12($_10) {
  return $_10.fields.address.addressLine2.placeholder;
}
function _temp13($_11) {
  return $_11.fields.address.addressLine2.internationalPlaceholder;
}
function _temp14($_12) {
  return $_12.fields.address.city.placeholder;
}
function _temp15($_13) {
  return $_13.fields.address.state.placeholder;
}
function _temp16($_14) {
  return $_14.fields.address.state.internationalPlaceholder;
}
function _temp17($_15) {
  return $_15.fields.address.zip.placeholder;
}
function _temp18($_16) {
  return $_16.fields.address.country.error;
}
function _temp19($_17) {
  return $_17.fields.address.addressLine1.error;
}
function _temp20($_18) {
  return $_18.fields.address.addressLine2.error;
}
function _temp21($_19) {
  return $_19.fields.address.city.error;
}
function _temp22($_20) {
  return $_20.fields.address.state.error;
}
function _temp23($_21) {
  return $_21.fields.address.zip.error;
}
function _temp24($_22) {
  return $_22.fields.address.country.disabledHint;
}